export default __webpack_public_path__ + "static/orssolution5-2bbef19753b6ddf3a18104deb684e0cf.svg";